import React from 'react';
import PropTypes from 'prop-types';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButtonGroup, RadioButton } from 'material-ui/RadioButton';
import { PERSON_TYPE } from '../../utils/constants';

export default function OwnerTypeSelector({ input, t, isDisabled, ...rest }) {
  return (
    <MuiThemeProvider>
      <RadioButtonGroup
        {...input}
        {...rest}
        valueSelected={input.value}
        onChange={(event, value) => input.onChange(value)}
        style={{ display: 'flex', width: '100%' }}
        disabled
      >
        <RadioButton
          disabled={isDisabled}
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={PERSON_TYPE.LEGAL_PERSON}
          label={t('account.legal')}
        />
        <RadioButton
          disabled={isDisabled}
          iconStyle={{ fill: '#646777' }}
          labelStyle={{ color: '#646777' }}
          value={PERSON_TYPE.NATURAL_PERSON}
          label={t('account.physical')}
        />
      </RadioButtonGroup>
    </MuiThemeProvider>
  );
}

OwnerTypeSelector.propTypes = {
  input: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

OwnerTypeSelector.defaultProps = {
  isDisabled: false,
};
